import * as React from 'react';
import { usePostRegEditDrawer } from '../../../../hooks/postRegEditDrawer/usePostRegEditDrawer';
import { BackendStaticStrings } from './types';
import { FormPage } from 'hooks/postRegEditDrawer';

const DefaultTitle = () => (
  <span className="sui-heading-sm">View and Edit Registration</span>
);

const ReviewTitle = () => (
  <span className="sui-heading-sm">Review Edits</span>
);

const PostRegEditDrawerTitle = () => {
  const { questions, formPage } = usePostRegEditDrawer();

  if (formPage === FormPage.Reviewing) {
    return <ReviewTitle />;
  }

  const { participantInfo } = questions || {};
  if (!participantInfo) {
    return <DefaultTitle />;
  }

  const { firstName, lastName } = participantInfo;
  if (
    (!firstName && !lastName) ||
    firstName === BackendStaticStrings.NO_RESPONSE ||
    lastName === BackendStaticStrings.NO_RESPONSE
  ) {
    return <DefaultTitle />;
  }

  const participantName = `${firstName} ${lastName}`;
  return (
    <span className="sui-heading-sm">
      View and Edit Registration:{' '}
      <span data-testid="participantName">{participantName}</span>
    </span>
  );
};

export default PostRegEditDrawerTitle;
